import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../i18n';

function HeaderRenderer(props) {
  const {t} = props;

  return (
    <span>
      <I18n t={t} />
    </span>
  );
}

HeaderRenderer.propTypes = {
  /** i18n translation key for the header text */
  t: PropTypes.string,
};

export default function(i18nKey) {
  return () => <HeaderRenderer t={i18nKey} />; //eslint-disable-line react/display-name
}
